import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import CylindoViewer from "components/cylindo-viewer";
import Image from "components/image";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import clsx from "clsx/lite";
import { useMediaQuery } from "react-responsive";
import { SCREEN_SIZES } from "utils/constants";

const verticalSwiperBreakpoints = {
	992: { direction: "vertical", spaceBetween: 8, slidesPerView: 5 },
	1140: { direction: "vertical", spaceBetween: 8, slidesPerView: 5.7 },
	1200: { direction: "vertical", spaceBetween: 10, slidesPerView: 6 },
	1280: { direction: "vertical", spaceBetween: 8, slidesPerView: 6 }
};

const ThumbnailSwiper = ({ filteredImages, setThumbsSwiper, verticalThumbsDesktop, title, showFiveSlides }) => {
	const isMobile = useMediaQuery({ maxWidth: SCREEN_SIZES.sm });
	return (
		<div className={clsx("relative thumbnail px-8 md:px-20", verticalThumbsDesktop && "lg:px-0 group/thumbnail h-full")}>
			<Swiper
				className={clsx(verticalThumbsDesktop && "lg:max-h-full min-h-full lg:!py-0", "py-4 max-h-52")}
				onSwiper={setThumbsSwiper}
				spaceBetween={showFiveSlides && isMobile ? 5 : 16}
				slidesPerView={showFiveSlides && isMobile ? 5 : 4}
				modules={[FreeMode, Navigation, Thumbs]}
				centerInsufficientSlides={true}
				direction="horizontal"
				navigation={{
					enabled: true,
					nextEl: ".gallery-thumbnail-bottom-arrow",
					prevEl: ".gallery-thumbnail-top-arrow",
					disabledClass: "lg:hidden"
				}}
				breakpoints={verticalThumbsDesktop ? verticalSwiperBreakpoints : {}}
			>
				{filteredImages.map((image) => (
					<SwiperSlide key={image?._key}
						className={clsx("thumbnail-item", verticalThumbsDesktop && "lg:!size-22 xl:!size-[100px]", image._type)}>
						{image?._type === "cylindo" ?
							<CylindoViewer code={image.code || title} initialFeatures={image?.features} isPreview /> :
							<Image image={image} />}
					</SwiperSlide>
				))}
			</Swiper>
			<button
				className={clsx(
					"gallery-thumbnail-top-arrow",
					filteredImages.length <= 4 && "hidden")}
			>
				<Arrow className={clsx(verticalThumbsDesktop && "lg:-rotate-90 lg:invert", "rotate-180")} />
			</button>
			<button
				className={clsx(
					"gallery-thumbnail-bottom-arrow",
					filteredImages.length <= 4 && "hidden")}
			>
				<Arrow className={clsx(verticalThumbsDesktop && "lg:rotate-90 lg:invert")} />
			</button>
		</div>
	);
};
export default ThumbnailSwiper;